import { gql } from 'graphql-tag'

export const FRAGMENT_SESSION_ITEMS = gql`
  fragment SessionItems on Session {
    token
    kid
  }
`
